// import { start } from "repl";

const matutaions = {
  SetOpenid(state, NewOpenid) { //方法名随意,主要是来承载变化的showFooter的值
    state.openId = NewOpenid;
  },
  SetuserInfo(state, userInfo) { //方法名随意,主要是来承载变化的showFooter的值
    state.userInfo = userInfo;
    state.islogin = true
  },
  ChangeIslogin(state, status) {
    state.islogin = status
  },
  ChangeLoginStatus(state, status) {
    state.showLogin = status
  },
  SetJSSDK(state, jssdkData) {
    state.JSSDK = jssdkData;
  },
  SetIconChartActive(state, iconChartActive) {
    state.iconChartActive = iconChartActive;
  },
  SetActivePath(state, activePath) {
    state.activePath = activePath;
  },
  SetActivePage(state, activePage) {
    state.activePage = activePage;
  },
  SetCollapseMenu(state, isCollapse) {
    state.isCollapse = isCollapse;
  },
  SetTableName(state, tableName) {
    state.tableName = tableName;
  },
  SetQueryData(state, status) {
    state.queryData = status;
  },
  // SetPlate(state,plate){
  //   state.plate=plate;
  // }
  // 保存下载数据
  SaveDownloadData(state, downloadData) {
    state.downloadData = downloadData
  },
  menuData(state, menuData) {
    state.menuData = menuData
  },
  curApi(state, curApi) {
    state.curApi = curApi
  },
  apiFirstTable(state, apiFirstTable) {
    state.apiFirstTable = apiFirstTable
  }
}

export default matutaions



// WEBPACK FOOTER //
// ./src/vuex/mutations.js